import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import SupervisiLimbahSvc from "@/services/SupervisiLimbahService";
import {
  SupervisiLimbah,
  SupervisiLimbahListFilter,
  SupervisiLimbahMeta
} from "@/types/SupervisiLimbah";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "supervisi-limbah"
})
class SupervisiLimbahModule extends VuexModule {
  items: SupervisiLimbah[] = [];
  currentItem: SupervisiLimbah | null = null;
  loading = false;
  meta: SupervisiLimbahMeta | null = null;

  @Mutation SET_ITEMS(val: SupervisiLimbah[]) {
    this.items = val || [];
  }

  @Mutation SET_CURRENT_ITEM(val: SupervisiLimbah | null) {
    this.currentItem = val;
  }

  @Mutation SET_META(val: SupervisiLimbahMeta | null) {
    this.meta = val || null;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async fetchList(params: SupervisiLimbahListFilter = {}) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiLimbahSvc.list(params);
      this.SET_ITEMS(dt.data.data || []);
      this.SET_META(dt.data.meta || null);
    } catch {
      this.SET_ITEMS([]);
      this.SET_META(null);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiLimbahSvc.find(id);
      this.SET_CURRENT_ITEM(dt.data.data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
    this.SET_META(null);
  }
}

export const storeSupervisiLimbah = getModule(SupervisiLimbahModule);
